import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default function navbar() {
    const windowWidth = window.outerWidth

    if (windowWidth < 1024) {    
        const nav = document.querySelector('.navbar nav'),
            toggler = document.querySelector('.toggler'),
            togglerCheckbox = document.getElementById('toggler-checkbox'),
            svg_bars = toggler.querySelector('.svg-bars'),
            svg_times = toggler.querySelector('.svg-times')
        console.log(svg_times)
        svg_times.classList.add('d-none')

        /* changer l'icone toggler pour le menu responsive */
        toggler.addEventListener('click', () => {
            if (!togglerCheckbox.checked) {
                svg_bars.classList.add('d-none')
                svg_times.classList.remove('d-none')
                disableBodyScroll(nav)
            } else {
                svg_bars.classList.remove('d-none')
                svg_times.classList.add('d-none')
                enableBodyScroll(nav)
            }
        })

        /* fermer le menu lors du clic sur un lien */
        const navLinks = nav.querySelectorAll('li a')

        navLinks.forEach(link => {
            link.addEventListener('click', () => {
                togglerCheckbox.checked = false
                svg_bars.classList.remove('d-none')
                svg_times.classList.add('d-none')
                enableBodyScroll(nav)
            })
        })
    }
}
